export const NARRATIVE_CITATIONS_FEATURE_FLAG = "narrative-citations";

export function isNarrativeCitationsEnabled(
  featureFlags?: string[] | null,
): boolean {
  return (featureFlags ?? []).includes(NARRATIVE_CITATIONS_FEATURE_FLAG);
}
